import { getAppDomain } from '../utils/domain'

export const getBaseUrl = () => getAppDomain()

export const DEFAULT_PANEL_SETTING = {
  skipGetAfterUpdateData: false,
  skipGetAfterUpdateTicket: false,
  skipGetAfterAddData: false,
  skipGetAfterDeleteData: false,
  reconcileAfterUpdateData: false,
  reconcileAfterUpdateTicket: false,
  reconcileAfterAddData: false,
  reconcileAfterDeleteData: false,
  asyncExcelBatch: true,
  asyncTicketApprove: false,
  asyncProductionVersion: false,
  asyncEnsureIndexes: false,
  // Read-only mirror of the service's MAX_BATCH_UPSERT_RECORDS, sent by GET /panel/setting.
  // Only used to reject an oversized file before upload; the service enforces it either way.
  maxBatchUpsertRecords: 100000,
}

export function normalizePanelSetting(raw) {
  const parsed = raw && typeof raw === 'object' ? raw : {}
  return {
    maxBatchUpsertRecords:
      Number.isFinite(parsed.maxBatchUpsertRecords) && parsed.maxBatchUpsertRecords > 0
        ? parsed.maxBatchUpsertRecords
        : DEFAULT_PANEL_SETTING.maxBatchUpsertRecords,
    skipGetAfterUpdateData:
      typeof parsed.skipGetAfterUpdateData === 'boolean'
        ? parsed.skipGetAfterUpdateData
        : DEFAULT_PANEL_SETTING.skipGetAfterUpdateData,
    skipGetAfterUpdateTicket:
      typeof parsed.skipGetAfterUpdateTicket === 'boolean'
        ? parsed.skipGetAfterUpdateTicket
        : DEFAULT_PANEL_SETTING.skipGetAfterUpdateTicket,
    skipGetAfterAddData:
      typeof parsed.skipGetAfterAddData === 'boolean'
        ? parsed.skipGetAfterAddData
        : DEFAULT_PANEL_SETTING.skipGetAfterAddData,
    skipGetAfterDeleteData:
      typeof parsed.skipGetAfterDeleteData === 'boolean'
        ? parsed.skipGetAfterDeleteData
        : DEFAULT_PANEL_SETTING.skipGetAfterDeleteData,
    reconcileAfterUpdateData:
      typeof parsed.reconcileAfterUpdateData === 'boolean'
        ? parsed.reconcileAfterUpdateData
        : DEFAULT_PANEL_SETTING.reconcileAfterUpdateData,
    reconcileAfterUpdateTicket:
      typeof parsed.reconcileAfterUpdateTicket === 'boolean'
        ? parsed.reconcileAfterUpdateTicket
        : DEFAULT_PANEL_SETTING.reconcileAfterUpdateTicket,
    reconcileAfterAddData:
      typeof parsed.reconcileAfterAddData === 'boolean'
        ? parsed.reconcileAfterAddData
        : DEFAULT_PANEL_SETTING.reconcileAfterAddData,
    reconcileAfterDeleteData:
      typeof parsed.reconcileAfterDeleteData === 'boolean'
        ? parsed.reconcileAfterDeleteData
        : DEFAULT_PANEL_SETTING.reconcileAfterDeleteData,
    asyncExcelBatch:
      typeof parsed.asyncExcelBatch === 'boolean'
        ? parsed.asyncExcelBatch
        : DEFAULT_PANEL_SETTING.asyncExcelBatch,
    asyncTicketApprove:
      typeof parsed.asyncTicketApprove === 'boolean'
        ? parsed.asyncTicketApprove
        : DEFAULT_PANEL_SETTING.asyncTicketApprove,
    asyncProductionVersion:
      typeof parsed.asyncProductionVersion === 'boolean'
        ? parsed.asyncProductionVersion
        : DEFAULT_PANEL_SETTING.asyncProductionVersion,
    asyncEnsureIndexes:
      typeof parsed.asyncEnsureIndexes === 'boolean'
        ? parsed.asyncEnsureIndexes
        : DEFAULT_PANEL_SETTING.asyncEnsureIndexes,
  }
}

/** Stable snapshot for comparing local table rows vs GET response. */
export function recordsSnapshot(records) {
  if (!Array.isArray(records)) return '[]'
  const normalized = records.map((record) => {
    const copy = { ...record }
    if (copy._id != null) copy._id = String(copy._id)
    return copy
  })
  normalized.sort((a, b) => String(a.key || '').localeCompare(String(b.key || '')))
  return JSON.stringify(normalized)
}

export function recordsEqual(a, b) {
  return recordsSnapshot(a) === recordsSnapshot(b)
}

/** Safe for CORS/network failures where response body is empty or unreadable. */
export function getAxiosErrorMessage(error, fallback = '網絡錯誤, 請稍後再試, 問題持續的話請通知i18n開發團隊協助') {
  try {
    const data = error?.response?.data
    if (data && typeof data === 'object' && data.msg != null) {
      return typeof data.msg === 'string' ? data.msg : JSON.stringify(data.msg)
    }
    const raw = error?.request?.response
    if (typeof raw === 'string' && raw.length > 0) {
      const parsed = JSON.parse(raw)
      if (parsed?.msg != null) {
        return typeof parsed.msg === 'string' ? parsed.msg : JSON.stringify(parsed.msg)
      }
    }
    if (error?.message) {
      return error.message
    }
  } catch (_) {
    // ignore JSON parse / access errors
  }
  return fallback
}

